import { createSelector } from 'reselect';

import { initialState } from './reducers';

const selectState = (state: any) => state.get('organizersPage') || initialState;

export const selectLoading = createSelector(selectState, (state) => state.get('loading'));

export const selectUpdating = createSelector(
  selectState,
  (_state: any, userId: string) => userId,
  (state, userId: string) => state.getIn(['updating', userId])
);

export const selectFetchParams = createSelector(selectState, (state) => state.get('fetchParams'));
